export const permissionsMap = {
  sub_admin_manager: '/sub-admin-manager',
  customers: '/users',
  company_manager: '/company',
  property_type_manager: '/property-types',
  property_category_manager: '/property-categories',
  amenities_manager: '/amenities',
  blog_manager: '/blogs',
  location_manager: '/city',
  subscription_manager: '/subscriptions',
  auction_manager: '/auction',
  transaction_manager: '/transactions',
  notification_managers: '/notifications',
  marketing_material_manager: '/marketing-material',
  ads_and_banner_manager: '/ads',
  reports_manager: '/reports',
  property_manager: '/properties',
  agent_manager: '/agents',
  approval_manager: '/approval-manager',
  query_listing_manager: '/query-manager',
  //careers: '/static/careers',
  careers: '/careers',
  about_us: '/static/about-us',
  contact_us: '/static/contact-us',
  faqs: '/static/faqs',
  import_faqs: '/static/faqs/import-faqs',
  privacy_policy: '/static/privacy-policy',
  terms_and_conditions: '/static/terms-and-conditions',
  settings: '/settings',
  project_manager: '/projects',
  menus_manager: '/top-menus',
  unit_manager: '/units',
  community_manager: '/community',
  project_status_manager: '/project-status',
  app_home_menu_manager: '/app-home-menu',
  mortgageSettings: '/mortgageSettings',
  units_report_manager: '/units-report',
  test_manager: '/test-manager',
  training_session_manager: '/training-sessions',
  activity_tracker_manager: '/activity-tracker',
  test_manager_tests: '/test-manager/tests',
  test_manager_tests_edit: '/test-manager/tests/edit/:id',
  test_manager_tests_details: '/test-manager/tests/details/:id',
  test_manager_question_bank: '/test-manager/question-bank',
  test_manager_submissions: '/test-manager/submissions',
  test_manager_submissions_details: '/test-manager/submissions/details/:id',
  test_manager_submissions_edit: '/test-manager/submissions/edit/:id',
  test_manager_submissions_delete: '/test-manager/submissions/delete/:id',
  order_manager: '/orders',
  order_discounts: '/order-discounts',
}
